import script from "./AdminLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminLayout.vue?vue&type=script&setup=true&lang=ts"

import "./AdminLayout.vue?vue&type=style&index=0&id=81836218&lang=css"

const __exports__ = script;

export default __exports__